import React, { useState } from "react";
import "./adminpanel.css";
import Navbar from '../../Navbar/Navbar';

const LOGIN_API_URL = "https://lfsofficial.in/api/admin_login.php";
const UPLOAD_API_URL = "https://lfsofficial.in/api/admin_upload.php";

const AdminPanel = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [file, setFile] = useState(null);
  const [category, setCategory] = useState("Affiliation Letter");
  const [uploadMessage, setUploadMessage] = useState("");
  const [uploading, setUploading] = useState(false);

  const DOCUMENT_CATEGORIES = [
    "Affiliation Letter",
    "COR Certificate",
    "Building Safety Certificate",
    "Fire Safety Certificate",
    "Self Certificate",
    "Water sefty declaration",
    "Socity Registration",
    
  ];

  // NOTE: Login state is only kept in memory (React state).
  // It resets on every page load/navigation, so the login form
  // always appears again — nothing is persisted in localStorage.

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("Please enter both User ID and Password.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(LOGIN_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json();

      if (data.success) {
        setIsLoggedIn(true);
      } else {
        setError(data.message || "Invalid User ID or Password.");
      }
    } catch (err) {
      setError(`Unable to reach the server: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUsername("");
    setPassword("");
    setFile(null);
    setUploadMessage("");
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setUploadMessage("");
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setUploadMessage("");

    if (!file) {
      setUploadMessage("Please choose a file first.");
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("category", category);
      // Re-send credentials so the backend can verify this upload is authorized
      formData.append("username", username);
      formData.append("password", password);

      const response = await fetch(UPLOAD_API_URL, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.success) {
        setUploadMessage("File uploaded successfully!");
        setFile(null);
        e.target.reset();
      } else {
        setUploadMessage(data.message || "Upload failed.");
      }
    } catch (err) {
      setUploadMessage(`Upload error: ${err.message}`);
    } finally {
      setUploading(false);
    }
  };

  // ---------- LOGGED IN VIEW: UPLOAD FORM ----------
  if (isLoggedIn) {
    return (
      <div className="admin-panel-container">
        <div className="admin-dashboard">
          <div className="admin-dashboard-header">
            <h2>Admin Panel</h2>
            <button className="admin-logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
          <p className="admin-welcome-text">Welcome, {username} 👋</p>

          <form className="admin-upload-form" onSubmit={handleUpload}>
            <label htmlFor="category">Document Type</label>
            <select
              id="category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              {DOCUMENT_CATEGORIES.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>

            <label htmlFor="fileUpload">Upload a file</label>
            <input type="file" id="fileUpload" onChange={handleFileChange} />
            <button
              type="submit"
              className="admin-upload-btn"
              disabled={uploading}
            >
              {uploading ? "Uploading..." : "Upload File"}
            </button>
          </form>

          {uploadMessage && (
            <p className="admin-upload-message">{uploadMessage}</p>
          )}
        </div>
      </div>
    );
  }

  // ---------- LOGIN VIEW ----------
  return (
    <div className="admin-panel-container">
      <form className="admin-login-box" onSubmit={handleLogin}>
        <h2 className="admin-login-title">Admin Login</h2>
        <p className="admin-login-subtitle">
          Please sign in to access the Admin Panel
        </p>

        {error && <div className="admin-error-message">{error}</div>}

        <div className="admin-input-group">
          <label htmlFor="username">User ID</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your User ID"
            autoComplete="username"
          />
        </div>

        <div className="admin-input-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your Password"
            autoComplete="current-password"
          />
        </div>

        <button type="submit" className="admin-login-btn" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
};

export default AdminPanel;